// import { Client, DatabaseAPI,  } from '@hiveio/dhive';
import { Client, DatabaseAPI } from 'dsteem';
import * as apiService from './api-service';
import { getSteemConfig } from '../config';
import base58 from 'bs58';
import getSlug from 'speakingurl';
import secureRandom from 'secure-random';
import { extractSessionData } from 'helpers/localStorage'; 
const getClient = () => new Client(getSteemConfig()); 
const getDB = () => new DatabaseAPI(getClient());

export function numberWithCommas(x) {
  try {
    if (typeof x != "string") {
      x = x.toString();
    }
    return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch (error) {
    console.log(error);
    return null;
    
  }
  
}

export async function getGlobalProperties() {  
  let global:any = await getDB().getDynamicGlobalProperties();
    return global;  
};

export function getAccount(account: string) {
  return getClient().database.getAccounts([account]);
}
export function getAccounts(list: any) {
  return getClient().database.getAccounts(list);
}
export function getReputation (reputation) {
    var rep = parseInt(reputation);
    if (rep == 0) return 25;
    if (rep > 0)  return Math.floor(9 * Math.log10(rep) - 56);
    else          return Math.ceil(106 - 9 * Math.log10(-rep));
}
export async function getSteemPerMvest(global) {
  let total_vesting_fund_steem = parseFloat(
    global.total_vesting_fund_steem.toString()
  );
  let total_vesting_shares = parseFloat(
    global.total_vesting_shares.toString()
  );
  let steemPerMvest =
    total_vesting_fund_steem / (total_vesting_shares / 1000000);
  return steemPerMvest;
}

export async function vestsToSteem(vests: number, global) {
  let steemPerMvest = await getSteemPerMvest(global);
  let result = (parseFloat(vests.toString()) * parseFloat(steemPerMvest.toString())) / 1000000000000;
  return result;
}
// export async function steemCustomApi (method:string, params:any) {
//   let data ;
//   console.log("RPC CALL:", method);

//   await apiService.post({
//     url: `${getSteemConfig()}`,
//     body: {
//       method: method,
//       id: 2,
//       params: params
//     }
//   }).then(response => { 
//     data = response;
//   }).catch(error => {
//     console.log(error);
//     data = []; 
//     return null;
//   });
//   return data; 
// } 
export async function steemCustomApi(method: string, params: any) { 
  try {
    const response = await apiService.post({
      url: getSteemConfig(),
      body: {
        jsonrpc: "2.0",
        method,
        params,
        id: 2
      }
    });

    if (!response) {
      throw new Error("Empty RPC response");
    }

    return response;
  } catch (error) {
    console.error("RPC ERROR:", method, error);
    return null; // 👈 IMPORTANTE
  }
}
export async function getSteemMarketCondition(url = "https://api.coingecko.com/api/v3/simple/price?ids=steem-dollars,steem&vs_currencies=usd&include_market_cap=true&include_24hr_vol=true&include_24hr_change=true") { 
  try {
    const response = await apiService.getHttp({
      url
    });

    if (!response) {
      throw new Error("Empty RPC response");
    }

    return response;
  } catch (error) {
    console.error("RPC ERROR:", error);
    return null; // 👈 IMPORTANTE
  }
}

function slug(text) {
  return getSlug(text.replace(/[<>]/g, ''), { truncate: 128 });
}
export async function createPermlink(title, author) {
  let permlink;
  if (title && title.trim() !== '') {
      let s = slug(title);
      if (s === '') {
          s = base58.encode(secureRandom.randomBuffer(4));
      }
      
      s = s.toLowerCase().replace(/[^a-z0-9-]+/g, '');
 
      const head = await steemCustomApi('bridge.get_post_header', {
          author,
          permlink: s,
      });
      if (head && !!head.category) {
          const noise = base58
              .encode(secureRandom.randomBuffer(4))
              .toLowerCase();
          permlink = noise + '-' + s;
      } else {
          permlink = s;
      } 
      if (permlink.length > 255) {
          permlink = permlink.substring(0, 255);
      }
  } else {
      permlink = Math.floor(Date.now() / 1000).toString(36);
  }

  return permlink;
}
// 🔹 Extrae todas las imágenes de un post (incluyendo portadas de YouTube)
export const getPostImages = (post: any): string[] => {
  let images: string[] = [];

  // 1️⃣ cover (si existe)
  if (post.cover && typeof post.cover === "string") {
    images.push(post.cover);
  }

  // 2️⃣ imágenes dentro del body
  const bodyText = typeof post.body === "string" ? post.body : "";
  const imageMatches = [
    ...bodyText.matchAll(/https?:\/\/[^\s"'<>]+\.(?:png|jpe?g|webp|gif)/gi),
  ];
  images.push(
    ...imageMatches.map((m) =>
      m[0].replace(/^[('"`]+/, "").replace(/[)'"`]+$/, "")
    )
  );


  images = images.map((url) => normalizeSteemitImage(url));

  return images;
};
// 🔹 Normaliza o agrega prefix de steemitimages
const normalizeSteemitImage = (url: string): string => {
  if (!url) return url;

  // Skip local assets
  if (url.startsWith("/assets/") || url.startsWith("assets/")) {
    return url;
  }

  // Case 1: already has steemitimages or hive images prefix -> normalize size or keep as is
  if (url.includes("steemitimages.com") || url.includes("images.hive.blog")) {
    // If it already has a size prefix, normalize it to 640x480
    if (url.match(/https?:\/\/[^\/]+\/\d+x\d+\//)) {
      return url.replace(
        /https?:\/\/[^\/]+\/\d+x\d+\//,
        "https://steemitimages.com/640x480/"
      );
    }
    // If it's a direct CDN link (like cdn.steemitimages.com/DQm...) keep it as is
    return url;
  }

  // Case 2: No prefix and not a known CDN -> add the proxy prefix
  return `https://steemitimages.com/640x480/${url}`;
};


export function getPostBody(cover, description, link){ 
  
  if (link.includes("ipfs")) {
    link = `[IPFS Video](${link})`;
  }
  let coverStr = !cover?``: `<div class="text-center">\n\n![Image cover](${cover})\n\n</div>`;
  let descriptionStr = !description?``:`${description}`;
  let body = `${coverStr}
<div class="text-justify">

${descriptionStr}

${link}


</div>
<div class="text-center"> 

<sup>Posted with [Speem](https://speem.watch/)</sup>

</div>`;
  return body;
} 
export function isLoggedWithKeychain(autologin:any){
  if (!autologin) {
    return true;
  }
  let data = extractSessionData(autologin);
  return data[0]?false:true;
}

export async function lookupAccounts(author: string, limit:number): Promise<any> {
  let result: any; 
  await apiService.post({
    url: `${getSteemConfig()}`,
    body: {
      method: "condenser_api.lookup_accounts",
      id: 2,
      params: [author, limit]
    }
  })
    .then((data: any) => {
      result = data;
    })
    .catch(() => {
      return [];
    })
  return result;
};